<template>
  <div class="detailCount">
    <div class="name">
      <span class="countName">{{ ruleForm.countName }}</span>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <el-button
          type="primary"
          size="small"
          class="editCount"
          v-show="!isEdit"
          @click="editCount"
        >
          编辑账户
        </el-button>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="账户名" prop="countName">
            <el-input
              v-model="ruleForm.countName"
              :maxlength="32"
              disabled
              placeholder="请输入账户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="userName">
            <el-input
              v-model="ruleForm.userName"
              :maxlength="32"
              :disabled="!isEdit"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="电子邮箱" prop="email">
            <el-input
              v-model="ruleForm.email"
              :disabled="!isEdit"
              placeholder="请输入电子邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              :disabled="!isEdit"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="department">
            <template v-if="selectDepart.length !== 0">
              <el-input
                v-for="item in selectDepart"
                :key="item.id"
                :value="item.name"
                readonly
                :disabled="!isEdit"
              >
              </el-input>
            </template>
            <template v-else>
              <el-input readonly placeholder="请选择部门"></el-input>
            </template>
            <el-button
              type="text"
              @click="openSetDepart"
              :disabled="!isEdit"
              v-show="isEdit"
              >设置</el-button
            >
          </el-form-item>
          <el-form-item label="启用状态" prop="enable">
            <el-switch
              v-model="ruleForm.enable"
              :disabled="!isEdit"
            ></el-switch>
          </el-form-item>
          <el-form-item label="管理员" prop="managered">
            <el-switch
              v-model="ruleForm.managered"
              :disabled="!isEdit"
            ></el-switch>
            <span class="testTip">管理员具有IDS管理平台所有权限</span>
          </el-form-item>
          <el-form-item>
            <div class="footer" v-show="isEdit">
              <el-button type="primary" @click="submitForm">确 定</el-button>
              <el-button @click="handleCancel">取 消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="组信息" name="second">
        <el-button type="primary" size="small" class="editCount" @click="addGroup">
          分配组
        </el-button>
        <group-list
          ref="groupList"
          :isDia="false"
          :tableData='tableData'
        ></group-list>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :current-page.sync="pageNum"
          :total="total"
          @current-change="pageChange"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="授权信息" name="third">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>{{ tip1 }}</p>
            <p>{{ tip2 }}</p>
          </div>
        </div>
        <AuthClientRoles
          ref="AuthClientRoles"
          :tableDataClient="tableDataClient"
          :tableDataAllClient="tableDataAllClient"
          modules="account"
          @postDepartClients="postDepartClients"
          @putDepAuthCliRoles="putDepAuthCliRoles"
        ></AuthClientRoles>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="分配组" width="500px" :visible.sync="dialogAddGroup" @close="submitAddGroup(true)">
      <group-list
        ref="groupListAdd"
        :isDia="true"
        :tableData='groupList'
        :selectGroup="selectGroup"
        @changeSelect="changeSelect"
      ></group-list>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddGroup(false)">确 定</el-button>
        <el-button @click="submitAddGroup(true)">取 消</el-button>
      </div>
    </el-dialog>
    <DialogSetDepart
      ref="dialogSetDepart"
      :selectAccount="selectAccount"
      :department="department"
      @setDepartment="setDepartment"
    ></DialogSetDepart>
  </div>
</template>

<script>
import { validatePhone, flatten } from "@/common/utils.js"
import DialogSetDepart from "@/components/common/Dialog/setDepart.vue"
import AuthClientRoles from "@/components/department/AuthClientRole.vue"
import groupList from "@/components//groupManage/groupList.vue"
import DepartAPIS from "@/apis/department.js"

import APIS from "@/apis/userManage.js"

export default {
  components: {
    DialogSetDepart,
    AuthClientRoles,
    groupList
  },
  data() {
    const checkCountName = (rule, value, callback) => {
      // let pattern = /^[0-9a-zA-Z-_.@]{4,32}$/
      callback()
      // value = value.trim()
      // if (value === "") {
      //   callback(new Error("请输入账户名"))
      // } else if (!pattern.test(value)) {
      //   callback(
      //     new Error(
      //       "支持大写字母、小写字母、数字、中划线(-)、下划线(_)、点(.)、@  ，长度至少 4 位"
      //     )
      //   )
      // } else {
      //   callback()
      // }
    }
    const checkDepartment = (rule, value, callback) => {
      if (this.selectDepart.length === 0) {
        callback(new Error("请选择部门名称"))
      } else {
        callback()
      }
    }
    return {
      dialogAddGroup: false, //列表弹框状态
      tableData: [],//已分配组列表
      groupList: [], //全部组
      tip1: "IDaaS支持为账户直接授权，同时账户也会继承部门和组的授权。",
      tip2:
        "通过账户授权获取的访问权限可以直接取消授权。通过继承关系获取的访问权限，需在对应的管理模块中完成取消授权的相关操作。",
      breadcrumb: [
        {
          label: "账户管理",
          url: "/userManage"
        },
        {
          label: "账户详情"
        }
      ],
      activeName: "first",
      ruleForm: {
        countName: "",
        userName: "",
        phone: "",
        email: "",
        department: [],
        enable: true,
        managered: false
      },
      realInfo:null,
      rules: {
        countName: [
          { required: true, validator: checkCountName, trigger: "blur" }
        ],
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入格式正确的邮箱地址",
            trigger: "blur"
          }
        ],
        phone: [{ validator: validatePhone, trigger: "blur" }],
        department: [
          { required: true, validator: checkDepartment, trigger: "blur" }
        ]
      },
      isEdit: false,
      realmName: this.$realm,
      accountId: "",
      preParams: null, // 缓存当前的参数
      selectDepart: [],
      oldSelectDepart: [],
      selectAccount: [],
      department: [],
      tableDataClient: [], // 账户已授权的应用
      tableDataAllClient: [], // 所有可授权的应用
      pageSize: 10,
      pageNum: 1,
      total: 0,
      selectGroup: []
    }
  },
  created() {
    this.accountId = this.$route.query.accountId
    this.activeName = this.$route.query.flag === "1" ? "second" : "first"
  },
  mounted() {
    if (this.accountId) {
      this.getRealmsUserInfor()
      this.getDepartments()
      this.getUserClients()
      this.getHasGroupList()
      this.getGroupList()
    }
  },
  methods: {
    // 分配组
    addGroup() {
      this.dialogAddGroup = true
      this.$nextTick(()=>{
        this.$refs.groupListAdd.toggleSelection(this.tableData)//就能拿到并进行自己的逻辑
      })
    },
    // 分配组关闭弹窗
    async submitAddGroup(type) {
      this.dialogAddGroup = false
      if(!type) {
        let params = {
          addGroupIds: [],
          remGroupIds: []
        }
        for(let j in this.selectGroup) {
          if(this.tableData.findIndex(item => item.id === this.selectGroup[j].id) < 0) {
            params.addGroupIds.push(this.selectGroup[j].id)
          }
        }
        for(let j in this.tableData) {
          if(this.selectGroup.findIndex(item => item.id === this.tableData[j].id) < 0) {
            params.remGroupIds.push(this.tableData[j].id)
          }
        }
        // 分配组
        let { status } = await APIS.addGroup(
          this.realmName,
          this.accountId,
          { data: params }
        )
        if (status === 0) {
          this.getHasGroupList()
        }
      }
      this.$refs.groupListAdd.toggleSelection(this.selectGroup)
    },
    // 查询账户已分配组列表
    async getHasGroupList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      let { status, data } = await APIS.getHasGroupList(this.realmName, this.accountId ,{
        params
      })
      this.total = 0
      this.tableData = []
      if (status === 0) {
        this.total = data.totalCount || 0
        if (data && data.data) {
          this.tableData = data.data
          this.selectGroup = data.data
        }
      }
    },
    // 查询账户组列表
    async getGroupList() {
      let { status, data } = await APIS.getGroupList(this.realmName, this.accountId)
      this.groupList = []
      if (status === 0) {
        if (data) {
          this.groupList = data
        }
      }
    },
    // 切换分页
    pageChange() {
      this.getHasGroupList()
    },
    // 分配组
    changeSelect(val) {
      this.selectGroup = val
    },
    // 获取用户授权应用
    async getUserClients() {
      let { status, data } = await APIS.getUserClients(
        this.realmName,
        this.accountId
      )
      this.tableDataClient = []
      this.tableDataAllClient = []
      if (status === 0) {
        data.forEach(item => {
          let obj = {
            id: item.id,
            clientId: item.clientId,
            clientName: item.clientName,
            role: item.roles,
            authMark: item.authMark
          }
          this.tableDataAllClient.push(obj)
          if (item.authMark) {
            this.tableDataClient.push(obj)
          }
        })
      }
    },
    // 给账户授权应用
    async putUserClients({ addCIds, remCIds }) {
      let params = {
        addCIds,
        remCIds
      }
      let { status } = await APIS.putUserClients(
        this.realmName,
        this.accountId,
        { data: params }
      )
      if (status === 0) {
        this.$refs.AuthClientRoles.dialogAuthClient = false
        this.getUserClients()
      }
    },
    // 给账户应用授权角色
    async putUserClientRoles({ clientId, addRoleMarks, remRoleMarks }) {
      let params = {
        addRoleMarks,
        remRoleMarks
      }
      let { status } = await APIS.putUserClientRoles(
        this.realmName,
        this.accountId,
        clientId,
        { data: params }
      )
      if (status === 0) {
        this.$refs.AuthClientRoles.dialogSetRoleVisible = false
        this.getUserClients()
      }
    },
    // 获取部门列表
    async getDepartments() {
      let { status, data } = await DepartAPIS.getDepartments(this.realmName)
      this.department = []
      if (!this.accountId) {
        this.selectDepart = []
      }
      if (status === 0) {
        this.department = data
        if (data && data[0]) {
          if (!this.accountId) {
            this.selectDepart = [
              {
                id: data[0].id,
                name: data[0].name,
                path: data[0].path
              }
            ]
          }
        }
      }
    },
    // 获取账户信息详情
    async getRealmsUserInfor() {
      let { status, data } = await APIS.getRealmsUserById(
        this.realmName,
        this.accountId
      )
      if (status === 0) {
        this.realInfo = data
        this.assignmentUserInfor(data)
      }
    },
    assignmentUserInfor(data) {
      this.ruleForm.countName = data && data.accountname
      this.ruleForm.userName = data && data.username
      this.ruleForm.phone = (data && data.telephone) || ""
      this.ruleForm.email = data && data.email
      this.ruleForm.enable = data && data.enabled
      this.ruleForm.managered = data && data.managered
      this.selectDepart = data && data.departments
      this.oldSelectDepart = data && JSON.parse(JSON.stringify(data.departments))
    },
    // 更新账户信息
    async putAccountInfor() {
      let params = {
        username: this.ruleForm.userName,
        accountname: this.ruleForm.countName,
        enabled: this.ruleForm.enable,
        email: this.ruleForm.email,
        telephone: this.ruleForm.phone,
        departments: this.selectDepart,
        managered: this.ruleForm.managered
      }
      let { status } = await APIS.putRealmsUserById(
        this.realmName,
        this.accountId,
        { data: params }
      )
      if (status === 0) {
        this.isEdit = false
        // 如果部门变化，需要更新账户的授权信息，因为账户的授权会继承于部门的。还需要更新账户信息，因为部门特殊
        if (
          JSON.stringify(this.selectDepart) !==
          JSON.stringify(JSON.parse(this.preParams).department)
        ) {
          this.getRealmsUserInfor()
          this.getUserClients()
        }
      }
    },
    // 编辑账户按钮
    editCount() {
      this.preParams = JSON.stringify({
        ruleForm: this.ruleForm,
        department: this.selectDepart
      })
      this.isEdit = true
    },
    // 给账户授权应用
    postDepartClients({ addCIds, remCIds }) {
      this.putUserClients({ addCIds, remCIds })
    },
    // 给账户应用授权角色
    putDepAuthCliRoles({ clientId, addRoleMarks, remRoleMarks }) {
      this.putUserClientRoles({ clientId, addRoleMarks, remRoleMarks })
    },
    // tab切换
    handleClick() {
      this.isEdit = false
      this.$refs["ruleForm"].resetFields()
      this.assignmentUserInfor(this.realInfo)
      if(this.activeName === 'third') {
        this.getUserClients()
      }
    },
    // 设置部门
    openSetDepart() {
      // 此处selectAccount不能放在计算属性中，弹窗消失后，里面的tree会初始化状态。如果放在计算属性中，则有可能计算后的值，在弹窗消失后被初始化了
      this.selectAccount =
        this.selectDepart.length === 0
          ? []
          : [
              {
                department: this.selectDepart
              }
            ]
      this.$nextTick(() => {
        this.$refs.dialogSetDepart.dialogSetDepartVisible = true
      })
    },
    // 确认设置部门信息
    setDepartment({ remDepartIds, addDepartIds }) {
      remDepartIds.length &&
        remDepartIds.forEach(id => {
          let index = this.selectDepart.findIndex(item => item.id === id)
          this.selectDepart.splice(index, 1)
        })
      addDepartIds.length &&
        addDepartIds.forEach(id => {
          let item = flatten(this.department, "subGroups").find(
            item => item.id === id
          )
          this.selectDepart.push({
            id: item.id,
            name: item.name,
            path: item.path
          })
        })
      this.$refs.dialogSetDepart.dialogSetDepartVisible = false
    },
    // 提交编辑表单
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          // 如果账户信息未改变，则不需要更新账户信息
          if (
            this.preParams ===
            JSON.stringify({
              ruleForm: this.ruleForm,
              department: this.selectDepart
            })
          ) {
            this.isEdit = false
            return false
          }
          this.putAccountInfor()
        }
      })
    },
    // 取消编辑账户详情信息
    handleCancel() {
      this.isEdit = false
      this.$refs["ruleForm"].resetFields()
      this.ruleForm = Object.assign({}, JSON.parse(this.preParams).ruleForm)
      this.selectDepart = JSON.parse(JSON.stringify(this.oldSelectDepart))
      console.log(this.setDepartment)
      /* this.selectDepart = Object.assign(
        {},
        JSON.parse(this.preParams).department
      ) */
    }
  }
}
</script>

<style lang="scss">
.detailCount {
  .name {
    margin-bottom: 16px;
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .el-form-item__content {
    .testTip {
      color: #999;
      font-size: 13px;
      margin-left: 20px;
      vertical-align: middle;
    }
    .el-button--text {
      position: absolute;
      margin-left: 14px;
      top: 6px;
    }
  }
  .el-tabs {
    .el-button.editCount {
      margin-bottom: 15px;
    }
    .authTip {
      display: flex;
      background-color: rgba(0, 112, 204, 0.05);
      font-size: 13px;
      color: #454647;
      padding: 10px;
      line-height: 22px;
      margin-bottom: 15px;
      align-items: center;
      i {
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
